import styled from 'styled-components';

import AllProducts from '../Products/AllProducts';
import { pxToRem } from '../../lib/utils';

export const StyledWrapper = styled.div`
  display: flex;
  min-height: 100%;
  flex-direction: column;
  background-color: ${({ hasLightBg, theme }) => (hasLightBg ? theme.colors.b : theme.colors.c)};
`;

export const StyledMain = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 0%;
  padding-top: ${({ theme }) => theme.sizes.headerHeight}px;
`;

export const StyledAllProducts = styled(AllProducts)`
  padding-top: ${pxToRem(40)};
`;
